<script setup>
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const fullWidthMode = inject('fullWidthMode', false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));

const props = defineProps({
  hData: Object,
  userName: String,
  hasPermission: Boolean,
  ratingResult: { type: Number, default: 0 },
  ratingStatus: { type: Boolean, default: false },
});

const emit = defineEmits(['postRate', 'goToOverView']);

const postRate = (rate) => emit('postRate', rate);
const goToCoverPage = () => {
  addContentLogAPI('ap_harmony_btn_restart');
  emit('goToOverView');
};
</script>

<template>
  <VRow class="full-height over-hidden">
    <!-- 왼쪽: 낭만만세력 소개 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="ending-page full-height right">
        <div class="ending-wrapper">
          <div class="nangman-footer">
            <div class="nangman-footer__character"></div>
            <div class="nangman-footer__content">
              <div class="nangman-footer__title">낭만만세력은</div>
              <div class="nangman-footer__text">
                <span>삶의 방향을 조율해가는&nbsp;</span>
                <span>따뜻한 이정표가 될 수 있도록&nbsp;</span><br />
                <span>지속적으로 연구하고,&nbsp;</span>
                <span>더 나은 서비스로 발전시켜 나가겠습니다.</span>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>

    <!-- 오른쪽: 설문 + 다시보기 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="ending-page full-height">
        <div class="ending-wrapper survey">
          <SurveyCard
            style="width: 100%"
            :ratingResult="ratingResult"
            :ratingStatus="ratingStatus"
            @postRate="postRate"
          />
          <div class="ending-replay">
            <button class="replay-btn content_review_button_restart" @click="goToCoverPage()">
              <i class="return-icon"></i>
              새 궁합 보기
            </button>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss" scoped>
.ending-page {
  border-radius: 0 !important;
  box-shadow: none !important;

  &.right {
    border-right: 1px solid var(--Gray-300, #ebebeb);
  }
}

.ending-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 24px;

  &.survey {
    height: 100%;
  }
}

.nangman-footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 531px;
  padding: 20px 32px;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  background: rgba(255, 107, 107, 0.05);
  text-align: center;

  &__character {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: url('@manseImages/yearly-fortune/img_year_guide_0104.png') center center no-repeat;
    background-size: cover;
    flex-shrink: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  &__title {
    color: #ff6b6b;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
  }

  &__text {
    max-width: 327px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
  }
}

.ending-replay {
  width: 100%;
  display: flex;
  justify-content: center;

  .replay-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    min-width: 160px;
    justify-content: center;
    border-radius: 6px;
    border: 1px solid #ebebeb;
    background: #fff;
    color: #333;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    cursor: pointer;

    .return-icon {
      display: block;
      width: 16px;
      height: 16px;
      background: url('/src/assets/images_manse/icon_return.svg') no-repeat center center;
      background-size: contain;
    }
  }
}
</style>
